import React from "react";
import { Container, Card, Badge } from "react-bootstrap";

export default function TermsOfUse() {
  return (
    <Container className="py-4">
      <Card className="shadow-sm">
        <Card.Body>
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
            <h2 className="mb-0">EMAlpha Mobile Application– Terms of Use</h2>
            <Badge bg="secondary">Last Updated: [01 Jan 2026]</Badge>
          </div>

          <p className="text-muted mb-4">
            These Terms of Use (“Terms”) govern your access to and use of mobile
            applications provided by <strong>EMAlpha LLC</strong> (“EMAlpha,” “we,”
            “us,” or “our”), including but not limited to <strong>CoTrader</strong>{" "}
            and <strong>MacroMonitor</strong> (collectively, the “Apps”).
          </p>

          <p>
            By downloading, installing, accessing, or using the Apps, you agree
            to be bound by these Terms.
          </p>

          <hr />

          {/* 1 */}
          <section className="mb-4">
            <h5>1. Acceptance of Terms</h5>
            <p>
              By using the Apps, you acknowledge that you have read and understood
              these Terms and agree to be legally bound by them. If you do not
              agree, do not use the Apps.
            </p>
          </section>

          {/* 2 */}
          <section className="mb-4">
            <h5>2. Eligibility & Global Use</h5>
            <ul>
              <li>You are at least 18 years old</li>
              <li>
                You are legally permitted to use financial analytics software in
                your jurisdiction
              </li>
              <li>
                You are not subject to economic sanctions or restricted-party
                lists (including OFAC or equivalent regimes)
              </li>
            </ul>
            <p>
              The Apps are intended for professional and non-professional users
              worldwide, subject to local law.
            </p>
          </section>

          {/* 3 */}
          <section className="mb-4">
            <h5>3. Account Registration & Security</h5>
            <ul>
              <li>Maintaining the confidentiality of your credentials</li>
              <li>All activity conducted through your account</li>
            </ul>
            <p>
              EMAlpha is not responsible for unauthorized access resulting from
              your failure to safeguard credentials.
            </p>
          </section>

          {/* 4 */}
          <section className="mb-4">
            <h5>4. No Investment Advice / No Fiduciary Duty</h5>
            <p className="fw-bold">IMPORTANT DISCLAIMER</p>
            <ul>
              <li>
                The Apps provide information, analytics, data visualization,
                sentiment analysis, and AI-generated insights for informational
                purposes only
              </li>
              <li>
                The Apps do not provide investment, trading, legal, or tax advice
              </li>
              <li>
                Nothing constitutes a recommendation to buy, sell, or hold any
                financial instrument
              </li>
              <li>
                EMAlpha does not act as a fiduciary, broker, dealer, investment
                adviser, or execution agent
              </li>
              <li>
                You remain solely responsible for all investment and trading
                decisions
              </li>
            </ul>
          </section>

          {/* 5 */}
          <section className="mb-4">
            <h5>5. Free & Paid Tiers</h5>
            <ul>
              <li>Free access tiers</li>
              <li>Paid subscriptions</li>
              <li>Enterprise or institutional arrangements</li>
            </ul>
            <p>
              Unless expressly stated otherwise, the same legal terms apply to
              all tiers. Fees are non-refundable except as required by law.
            </p>
          </section>

          {/* 6 */}
          <section className="mb-4">
            <h5>6. Intellectual Property & License</h5>
            <p>
              All rights, title, and interest in the Apps—including software,
              models, algorithms, scores, prompts, analytics, and content—are
              owned by EMAlpha or its licensors.
            </p>
            <p>
              You are granted a limited, non-exclusive, non-transferable,
              revocable license to use the Apps for internal, lawful purposes
              only.
            </p>
            <ul>
              <li>Reverse engineer or decompile models</li>
              <li>Repackage outputs as a competing product</li>
              <li>Train competing AI systems using App outputs</li>
              <li>Scrape or bulk-extract data</li>
            </ul>
          </section>

          {/* 7 */}
          <section className="mb-4">
            <h5>7. Acceptable Use</h5>
            <ul>
              <li>Unlawful or deceptive purposes</li>
              <li>Circumventing security or usage limits</li>
              <li>Automated scraping or bulk extraction</li>
              <li>Publishing benchmarks without consent</li>
            </ul>
          </section>

          {/* 8 */}
          <section className="mb-4">
            <h5>8. Third-Party Data & Services</h5>
            <p>
              The Apps may incorporate third-party data or integrations. Such
              data may be delayed, incomplete, or inaccurate. EMAlpha does not
              control third-party services.
            </p>
          </section>

          {/* 9 */}
          <section className="mb-4">
            <h5>9. Limitation of Liability</h5>
            <p>
              To the maximum extent permitted by law, EMAlpha shall not be liable
              for trading losses, lost profits, or reliance on analytics.
            </p>
            <p>
              EMAlpha’s total liability shall not exceed fees paid in the prior
              12 months or USD $100 if no fees were paid.
            </p>
          </section>

          {/* 10 */}
          <section className="mb-4">
            <h5>10. Indemnification</h5>
            <p>
              You agree to indemnify and hold harmless EMAlpha from claims arising
              out of your use of the Apps or violation of these Terms.
            </p>
          </section>

          {/* 11 */}
          <section className="mb-4">
            <h5>11. Suspension & Termination</h5>
            <p>
              EMAlpha may suspend or terminate access for violations, legal
              requirements, or to protect system integrity.
            </p>
          </section>

          {/* 12 */}
          <section className="mb-4">
            <h5>12. Governing Law & Dispute Resolution</h5>
            <p>
              These Terms are governed by the laws of the State of New York.
              Disputes shall be resolved through binding arbitration on an
              individual basis only.
            </p>
          </section>

          {/* 13 */}
          <section className="mb-4">
            <h5>13. App Store Acknowledgements</h5>
            <p>
              Apple Inc. and Google LLC are not parties to these Terms and bear no
              responsibility for the Apps.
            </p>
          </section>

          {/* 14 */}
          <section>
            <h5>14. Changes to Terms</h5>
            <p>
              EMAlpha may update these Terms from time to time. Continued use of
              the Apps constitutes acceptance of the updated Terms.
            </p>
          </section>
        </Card.Body>
      </Card>
    </Container>
  );
}
